// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «База знань партії» (Party knowledge base, ключ `pkb`, група `party-and-group`). */
export const partyKnowledgeBaseManifest: IModuleManifest = {
  key: 'pkb',
  group: 'party-and-group',
  slug: 'party-knowledge-base',
  prefix: 'PKB',
  name: { en: 'Party knowledge base', uk: 'База знань партії' },
  entities: [
    { key: 'pkb', slug: 'pkb', name: { en: 'Articles', uk: 'Статті' }, main: true },
    { key: 'pfaq', slug: 'pfaq', name: { en: 'Questions & answers', uk: 'Питання та відповіді' }, main: false },
  ],
  loadState: () => import('./state/partyKnowledgeBaseSlice').then((m) => m.partyKnowledgeBaseSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
